<footer class="main-footer no-print">
  <div class="float-right d-none d-sm-block">
    <b>Version</b> {{ appVersion }}
  </div>
  Todos os direitos reservados SECONT-ES
</footer>